/* eslint react/require-default-props: 0 */

import React, { useState, useRef, useEffect } from 'react';
import { Box, TextField } from '@mui/material';
import { VerifyOtpStyleWrapper } from './otpInput-style';

type ChangeHandler = (otpValue: string, length: number) => void;

interface IProps {
    length?: number;
    autoFocus?: boolean;
    type?: string;
    placeholder?: any;
    showText?: boolean;
    isValidOtp?: boolean;
    onChange: ChangeHandler;
}

export const OtpInput = ({
    length = 6,
    onChange,
    autoFocus = true,
    type = 'text',
    placeholder = ['', '', '', '', '', ''],
    showText = true,
    isValidOtp,
}: IProps) => {
    const [otp, setOtp] = useState(Array(length).fill(''));
    const inputRefs = useRef<Array<HTMLInputElement | null>>(Array.from({ length }, () => null));
    const otpKeys = ['otp-1', 'otp-2', 'otp-3', 'otp-4', 'otp-5', 'otp-6'];
    useEffect(() => {
        if (inputRefs.current[0] && autoFocus) {
            // @ts-expect-error: inputRefs may not have .focus() due to missing DOM lib
            inputRefs.current[0].focus();
        }
    }, [autoFocus]);

    useEffect(() => {
        if (!isValidOtp) {
            setOtp(Array(6).fill(''));
        }
    }, [isValidOtp]);

    const handleInputChange = (value: string, index: number) => {
        const sanitizedValue = value.replace(/\D/g, '');
        const newOtp = [...otp];
        newOtp[index] = sanitizedValue;
        setOtp(newOtp);
        onChange(newOtp.join(''), length);
        if (sanitizedValue !== '' && index < length - 1) {
            if (inputRefs?.current[index + 1]) {
                // @ts-expect-error: inputRefs may not have .focus() due to missing DOM lib
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const handleKeyDown = (e: any, index: any) => {
        if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
            // @ts-expect-error: inputRefs may not have .focus() due to missing DOM lib
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>, index: number) => {
        e.preventDefault();
        const pastedData = (e.clipboardData as any).getData('text/plain');
        const pastedValues = pastedData.split('').slice(0, length);
        const newOtp = [...otp];
        pastedValues.forEach((value: any, i: any) => {
            if (inputRefs.current?.[index + i]) {
                newOtp[index + i] = value;
            }
        });
        setOtp(newOtp);
        onChange(newOtp.join(''), length);
    };
    return (
        <VerifyOtpStyleWrapper>
            <Box className="otpContainer" mb={2}>
                {otp.map((digit: number, index: number) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Box key={`otp-box-${digit}-${otpKeys[index]}`}>
                        <TextField
                            placeholder={placeholder[index]}
                            // eslint-disable-next-line react/no-array-index-key
                            key={`otp-input-${digit}-${otpKeys[index]}`}
                            type={showText ? 'text' : type}
                            value={digit}
                            onChange={(e: any) => handleInputChange(e.target.value, index)}
                            onKeyDown={e => handleKeyDown(e, index)}
                            inputRef={ref => {
                                inputRefs.current[index] = ref;
                            }}
                            onPaste={(e: any) => handlePaste(e, index)}
                            variant="outlined"
                            autoComplete="off"
                            inputProps={{ maxLength: 1 }}
                        />
                    </Box>
                ))}
            </Box>
        </VerifyOtpStyleWrapper>
    );
};
